export enum Parent {
  EBTEDAEI = 1,
  MOTEVASET_AVAL = 2,
  MOTEVASET_DOVOM = 3,
}
